/** Options for running profile forms */

export const RUNNER_EXPERIENCE_LEVELS = [
  { value: 'BEGINNER', label: 'Beginner (new to running or returning after a break)' },
  { value: 'INTERMEDIATE', label: 'Intermediate (regular runner, some race experience)' },
  { value: 'ADVANCED', label: 'Advanced (consistent training, race-focused)' },
];

export const RUNNER_WEEKLY_MILEAGE = [
  { value: 'UNDER_10', label: 'Under 10 miles / week' },
  { value: 'TEN_TO_TWENTY', label: '10–20 miles / week' },
  { value: 'TWENTY_TO_THIRTY', label: '20–30 miles / week' },
  { value: 'THIRTY_PLUS', label: '30+ miles / week' },
];

export const RUNNER_PREFERRED_DISTANCES = [
  { value: '5K', label: '5K' },
  { value: '10K', label: '10K' },
  { value: 'HALF_MARATHON', label: 'Half marathon' },
  { value: 'MARATHON', label: 'Marathon' },
  { value: 'TRAIL', label: 'Trail / off-road' },
];

export const RUNNER_GROUP_PREFERENCES = [
  { value: 'SOCIAL', label: 'Social (easy pace, conversation)' },
  { value: 'TRAINING', label: 'Training (structured workouts)' },
  { value: 'RACE_PACE', label: 'Race pace (faster group runs)' },
];

export function formatRunnerExperience(value) {
  return RUNNER_EXPERIENCE_LEVELS.find((o) => o.value === value)?.label || value || '—';
}

export function formatRunnerWeeklyMileage(value) {
  return RUNNER_WEEKLY_MILEAGE.find((o) => o.value === value)?.label || value || '—';
}

export function formatRunnerGroupPreference(value) {
  return RUNNER_GROUP_PREFERENCES.find((o) => o.value === value)?.label || value || '—';
}

export function formatRunnerDistance(value) {
  return RUNNER_PREFERRED_DISTANCES.find((o) => o.value === value)?.label || value;
}

export function formatPace(minPerMile) {
  if (minPerMile == null || Number.isNaN(minPerMile)) return '—';
  const minutes = Math.floor(minPerMile);
  const seconds = Math.round((minPerMile - minutes) * 60);
  return `${minutes}:${String(seconds).padStart(2, '0')} / mile`;
}
